// extracted by mini-css-extract-plugin
module.exports = {"root":"accordion-content_root__B4wgl","slideDown":"accordion-content_slideDown__KH9A1","slideUp":"accordion-content_slideUp__49Lg2","content":"accordion-content_content__EJM3k"};